@import './../afs-navbar-common'

header
    height: var(--nav-height)

    .fixed-navbar
        height: var(--nav-height)

        .logobox
            height: var(--logo-height)

        .right-container
            .ascend-logobox
                height: var(--afs-logo-height)